import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// actions
import { changelayoutMode } from "../../redux/actions";

// components
import SideMenu from "./SideMenu";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { useChatPrefetch } from "../../hooks/useChatPrefetch";
import { useGlobalWebSocket } from "../../hooks/useGlobalWebSocket"; // ✅ WebSocket global

interface IndexProps {
  children: any;
}

const Index = (props: IndexProps) => {
  const dispatch = useDispatch();
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const breakpointInfo = useBreakpoint();

  useChatPrefetch();
  useGlobalWebSocket(); //  Conecta WebSocket globalmente para TODAS as páginas

  const onChangeLayoutMode = (value: any) => {
    if (changelayoutMode) {
      dispatch(changelayoutMode(value));
    }
  };

  // Função auxiliar para encontrar o elemento da sidebar
  const findSidebarElement = (layoutWrapper: Element) => {
    const firstChild = layoutWrapper.firstElementChild;
    return firstChild;
  };

  // Effect para automaticamente fechar a sidebar quando a tela é menor que 1024px
  useEffect(() => {
    // Se a tela for menor que 1024px (mobile ou tablet), fechar a sidebar
    if (breakpointInfo.isMobile || breakpointInfo.isTablet) {
      setIsSideMenuOpen(false);

      // Esconder o menu desktop (que aparece em tablets 900px-1024px)
      // O Drawer do Material-UI renderiza em um portal, então não será afetado
      // O Drawer é controlado pelo prop isOpen, que já está sendo setado como false
      setTimeout(() => {
        const layoutWrapper = document.querySelector(".layout-wrapper");
        if (layoutWrapper) {
          const sideMenuElement = findSidebarElement(layoutWrapper);
          if (sideMenuElement) {
            // Esconder o elemento da sidebar (será o menu desktop em tablets)
            // O Drawer não será afetado pois renderiza em um portal
            (sideMenuElement as HTMLElement).style.display = "none";
          }
        }
      }, 10);
    } else {
      // Se a tela for >= 1024px (desktop), mostrar a sidebar desktop
      setTimeout(() => {
        const layoutWrapper = document.querySelector(".layout-wrapper");
        if (layoutWrapper) {
          const sideMenuElement = findSidebarElement(layoutWrapper);
          if (sideMenuElement) {
            (sideMenuElement as HTMLElement).style.display = "";
          }
        }
      }, 10);
    }
  }, [breakpointInfo.isMobile, breakpointInfo.isTablet]);

  // Detectar mudanças no localStorage para abrir/fechar o menu
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent | CustomEvent) => {
      if ("key" in e && e.key === "sidebar") {
        // Só atualizar se não estiver em mobile/tablet
        if (!breakpointInfo.isMobile && !breakpointInfo.isTablet) {
          setIsSideMenuOpen(e.newValue === "expanded");
        }
      } else if ("detail" in e) {
        // Custom event disparado pelo ChatJessPage
        setIsSideMenuOpen((e as CustomEvent).detail.isOpen);
      }
    };

    window.addEventListener("storage", handleStorageChange as EventListener);
    window.addEventListener(
      "sidebarToggle",
      handleStorageChange as EventListener,
    );

    return () => {
      window.removeEventListener(
        "storage",
        handleStorageChange as EventListener,
      );
      window.removeEventListener(
        "sidebarToggle",
        handleStorageChange as EventListener,
      );
    };
  }, [breakpointInfo.isMobile, breakpointInfo.isTablet]);

  return (
    <div className="layout-wrapper h-100 d-lg-flex" style={{ display: "flex" }}>
      <SideMenu
        onChangeLayoutMode={onChangeLayoutMode}
        isOpen={isSideMenuOpen}
        onClose={() => setIsSideMenuOpen(false)}
      />
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          position: "relative",
          display: "flex !important", // Força display flex sempre, mesmo no mobile
          flexDirection: "column",
          // Sem padding-bottom, pois não há mais bottom bar
        }}
      >
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {props.children}
        </Box>
      </Box>
      <ToastContainer autoClose={2000} />
    </div>
  );
};

export default Index;
